import React from "react";
import { FormattedMessage } from "react-intl";
import { Card, Row } from "@masterteam/mt-design-react";

import "./style.scss";

const DetailsCard = ({ icon, title, children }) => {
  return (
    <Card className="details-card">
      <Row className="details-card__title" align="center" gap={8}>
        {icon ? icon : null}
        <FormattedMessage id={title} />
      </Row>

      <div className="details-card__content">{children}</div>
    </Card>
  );
};

export default DetailsCard;
